<template lang="pug">
  base-content(ref="main" title="役務依頼申請書<span class=\"nopdf\">の作成</span>", :subtitle="subtitle", :type="titleType")
    form(@submit.prevent="submit", data-testid="form-app")
      app-message(v-if="appErrorMessage" type="danger") {{appErrorMessage}}
      app-message(v-if="appInfoMessage" type="info") {{appInfoMessage}}

      button-bar(@downloadDataFile="downloadDataFile" @importData="importData")

      section.section

        form-header(v-if="nextTicker", v-model="postData.application")

        h3#editions.title.required 対象エディション

        section.section.checkbox-field(data-testid="editions")
          b-field.required(
            :class="{'unselected': !postData.editions.length || getInputType('editions') === 'is-danger'}"
            :message="getInputMessage('editions')"
            :type="getInputType('editions')"
          )
            section
              .columns.is-multiline(v-if="isEdit")
                .column.is-half(v-for="item in options.editions" :key="item.key")
                  b-checkbox(v-model="postData.editions" :native-value="item.value" name="editions[]" :data-testid="item.key") {{item.label}}
              template(v-else)
                p(v-for="item in postData.editions") {{getOptionLabelByValue(options.editions, item)}}

              b-field(
                :message="getInputMessage('editions_other')"
                :type="getInputType('editions_other')"
              )
                b-input(
                  v-if="isEdit",
                  v-model="postData.editions_other",
                  name="editions_other",
                  :disabled="!isOptionKeySelected(options.editions, 'otherEdition', postData.editions)",
                  :required="isOptionKeySelected(options.editions, 'otherEdition', postData.editions)",
                  :maxlength="maxlen_srq.editions_other",
                  v-validate="",
                  data-vv-as="その他",
                  placeholder="「その他」を選択した場合、こちらに入力してください。",
                  data-testid="editions_other"
                )
                p(v-else-if="isOptionKeySelected(options.editions, 'otherEdition', postData.editions)") {{postData.editions_other}}
          p.help.is-danger(v-if="!postData.editions.length") 「対象エディション」のうち、いずれか一つを選択してください。

        h3#categories.title.required 購入区分詳細

        section.section.checkbox-field(data-testid="categories")
          b-field.required(
            :class="{'unselected': !postData.categories.length || getInputType('categories') === 'is-danger'}"
            :message="getInputMessage('categories')"
            :type="getInputType('categories')"
          )
            section
              .columns.is-multiline(v-if="isEdit")
                .column.is-half(v-if="!['ASAppInsteadCreateService', 'otherCategory'].includes(item.key)" v-for="item in options.categories" :key="item.key")
                  b-checkbox(v-model="postData.categories" :native-value="item.value" name="categories[]" :data-testid="item.key") {{item.label}}
              template(v-else)
                p(v-if="![getCategory('ASAppInsteadCreateService').value, getCategory('otherCategory').value].includes(item)" v-for="item in postData.categories") {{getOptionLabelByValue(options.categories, item)}}

              .field(v-if="isEdit")
                b-checkbox(v-model="postData.categories" :native-value="getCategory('ASAppInsteadCreateService').value" name="categories[]" :data-testid="getCategory('ASAppInsteadCreateService').key") {{getCategory('ASAppInsteadCreateService').label}}
                .agree
                  p(:class="{'has-text-grey-light': !isOptionKeySelected(options.categories, 'ASAppInsteadCreateService', postData.categories)}")
                    | AppSuiteアプリ作成代行サービスの購入にあたって、以下サービス約款を事前にご確認ください。
                    br
                    a(href="https://www.desknets.com/neo/pdf/article_applicreate.pdf", target="_blank") https://www.desknets.com/neo/pdf/article_applicreate.pdf
                    br
                    | 申請書をご提出いただいたことで、サービス約款に同意いただいたものとさせていただきます。
              template(v-else-if="isOptionKeySelected(options.categories, 'ASAppInsteadCreateService', postData.categories)")
                p {{getCategory('ASAppInsteadCreateService').label}}
                .agree
                  p AppSuiteアプリ作成代行サービスの購入にあたって、以下サービス約款を事前にご確認ください。
                    br
                    a(href="https://www.desknets.com/neo/pdf/article_applicreate.pdf", target="_blank") https://www.desknets.com/neo/pdf/article_applicreate.pdf
                    br
                    | 申請書をご提出いただいたことで、サービス約款に同意いただいたものとさせていただきます。
              .field(v-if="isEdit")
                b-checkbox(v-model="postData.categories" :native-value="getCategory('otherCategory').value" name="categories[]" :data-testid="getCategory('otherCategory').key") {{getCategory('otherCategory').label}}
              p(v-else-if="isOptionKeySelected(options.categories, 'otherCategory', postData.categories)") {{getCategory('otherCategory').label}}

              b-field(
                :message="getInputMessage('categories_other')"
                :type="getInputType('categories_other')"
              )
                b-input(
                  v-if="isEdit",
                  v-model="postData.categories_other",
                  name="categories_other",
                  :disabled="!isOptionKeySelected(options.categories, 'otherCategory', postData.categories)",
                  :required="isOptionKeySelected(options.categories, 'otherCategory', postData.categories)",
                  :maxlength="maxlen_srq.categories_other",
                  v-validate="",
                  data-vv-as="その他",
                  placeholder="「その他」を選択した場合、こちらに入力してください。",
                  data-testid="categories_other"
                )
                p(v-else-if="isOptionKeySelected(options.categories, 'otherCategory', postData.categories)") {{postData.categories_other}}
          p.help.is-danger(v-if="!postData.categories.length") 「購入区分詳細」のうち、いずれか一つを選択してください。

        h3.title エンドユーザー様情報
        form-user(v-if="nextTicker", v-model="postData.application" prefix="end_")

        template(v-if="isPartnerApp()")
          h3.title エンドユーザー様へ販売されるパートナー様情報
          form-user(v-if="nextTicker", v-model="postData.application" prefix="partner_")

      button-bar(@downloadDataFile="downloadDataFile" @importData="importData")
</template>

<script>
import BaseContent from '@/components/BaseContent'
import ButtonBar from '@/components/apps/com/ButtonBar'
import FormHeader from '@/components/apps/com/FormHeader'
import FormUser from '@/components/apps/com/FormUser'
import AppMessage from '@/components/AppMessage'
import MixinApplication from '@/mixins/application'
import MixinHandleErrors from '@/mixins/handleErrors'
import { Applications as maxlen_app, AppServiceRequests as maxlen_srq } from '@/config/maxlengths'
import Util from '@/utils/util'

export default {
  name: 'ServiceRequest',
  mixins: [ MixinApplication, MixinHandleErrors ],
  components: {BaseContent, ButtonBar, FormHeader, FormUser, AppMessage},
  data () {
    return {
      maxlen_app,
      maxlen_srq,
      Util,
      postData: {
        application: {
          order_no: '',
          estimate_no: ''
        },
        editions: [],
        editions_other: '',
        categories: [],
        categories_other: ''
      },

      /**
       * 選択肢の定義
       * options[ここはフィールド名]
       */
      options: {
        editions: [
          {
            key: 'neo',
            label: 'desknet\'s NEO',
            value: 'p'
          },
          {
            key: 'app',
            label: 'AppSuite',
            value: 'q'
          },
          {
            key: 'web',
            label: 'ウェブ会議',
            value: 'r'
          },
          {
            key: 'deskCams',
            label: 'desknet\'s CAMS',
            value: 'j'
          },
          {
            key: 'denbun',
            label: 'DenbunPOP/IMAP',
            value: 'k'
          },
          {
            key: 'chatLuck',
            label: 'ChatLuck',
            value: 'l'
          },
          // #333 にて削除
          // {
          //   key: 'equipmentReserve',
          //   label: '設備予約表示システム',
          //   value: 'm'
          // },
          // #333 にて追加
          {
            key: 'deskNeoASCloud',
            label: "desknet's NEO・AppSuiteクラウド版",
            value: 'o'
          },
          {
            key: 'otherEdition',
            label: 'その他',
            value: 'n'
          }
        ],
        categories: [
          {
            key: 'edicationForAdmin',
            label: '管理者向け教育',
            value: 'a'
          },
          {
            key: 'edicationForUser',
            label: 'ユーザー向け教育',
            value: 'b'
          },
          {
            key: 'install',
            label: 'インストール',
            value: 'c'
          },
          {
            key: 'verUpOnPre',
            label: 'バージョンアップ（オンプレ）',
            value: 'd'
          },
          {
            key: 'verUpCloud',
            label: 'バージョンアップ（クラウド）',
            value: 'e'
          },
          {
            key: 'migDataOnPre',
            label: 'データ移行（オンプレ）',
            value: 'f'
          },
          {
            key: 'migDataCloud',
            label: 'データ移行（クラウド）',
            value: 'g'
          },
          // #375にて削除
          // {
          //   key: 'ASAppCreateService',
          //   label: 'AppSuiteアプリ作成伴奏サービス',
          //   value: 'i'
          // },
          // #375にて追加
          {
            key: 'ASAppInsteadCreateService',
            label: 'AppSuiteアプリ作成代行サービス',
            value: 'j'
          },
          {
            key: 'otherCategory',
            label: 'その他',
            value: 'h'
          }
        ],
      },

      // PDF作成処理失敗によるエラーメッセージ
      appErrorMessage: '',
      appInfoMessage: ''
    }
  },
  methods: {
    /**
     * 指定した購入区分詳細を取得する
     */
    getCategory (key) {
      return this.options.categories.find(item => item.key === key)
    },
    app_getSubmitData () {
      // 共通処理
      let submitData = this.getSubmitData()

      // 個別処理
      submitData.categories = submitData.categories.join(',')
      submitData.editions = submitData.editions.join(',')

      return submitData
    },
    app_validationCheck () {
      if (!this.postData.editions.length) {
        // エラー位置までスクロールする
        Util.scrollToEl(document.getElementById('editions'))
        return false
      }
      if (!this.postData.categories.length) {
        // エラー位置までスクロールする
        Util.scrollToEl(document.getElementById('categories'))
        return false
      }
      return true
    },
    app_setImportData (importData) {
      // 共通処理
      this.setImportData(importData, this.postData)

      // 購入ライセンスエディション
      if ('editions' in importData) {
        if (importData.editions.length > 0) {
          this.postData.editions = importData.editions.split(',')
        }
        // 配列以外のものがインポートされていた場合、空配列で上書きする
        if (!Array.isArray(this.postData.editions)) {
          this.postData.editions = []
        }
      }

      // 購入区分詳細
      if ('categories' in importData) {
        if (importData.categories.length > 0) {
          this.postData.categories = importData.categories.split(',')
        }
        // 配列以外のものがインポートされていた場合、空配列で上書きする
        if (!Array.isArray(this.postData.categories)) {
          this.postData.categories = []
        }
      }
    }
  },
  created () {
    this.mode = 'edit'
    this.postData.application = Object.assign(this.postData.application, this.postData__application)
    this.postData.application.app_code = 'srq'
  }
}
</script>

<style scoped>
.agree {
  margin-left: 1.75rem;
  padding-bottom: 0.75rem;
}
.agree .block {
  margin-left: 1.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/ServiceRequest.vue